import { FormattedMessage } from 'react-intl'
import styled from '@emotion/styled'
import { spacing, colors, fontSize } from '@retailer-platform/shared-components/src/foundation'
import { humanizeToolName } from './approvalHelpers'
import type { MutationPreview } from '../hooks/useRetailerAgentChat'

interface Props {
  preview: MutationPreview
  status: 'approved' | 'cancelled'
  settledAt: number
}

const Pill = styled.span<{ ok: boolean }>(({ ok }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: spacing.X8,
  padding: `${spacing.X8} ${spacing.X12}`,
  background: colors.GRAYSCALE.X20,
  border: `1px solid ${colors.GRAYSCALE.X30}`,
  borderRadius: 8,
  fontSize: fontSize.X12,
  color: colors.GRAYSCALE.X70,
  '& .check': {
    color: ok ? colors.SUCCESS.REGULAR : colors.GRAYSCALE.X60,
  },
}))

function formatTime(ts: number): string {
  return new Date(ts).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
}

export function ApprovalCardSettled({ preview, status, settledAt }: Props) {
  const isApproved = status === 'approved'
  return (
    <Pill ok={isApproved}>
      <span className="check">{isApproved ? '✓' : '✕'}</span>
      <FormattedMessage id={`retailerAgent.approval.settled.${status}` as const} />
      {' · '}
      {humanizeToolName(preview.toolName)}
      {' · '}
      {formatTime(settledAt)}
    </Pill>
  )
}
